module.exports = __webpack_public_path__ + "images/homepage-verified-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-verified-icon.svg
// module id = 858
// module chunks = 0